import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import type {
  DeleteFlowPayloadT,
  FetchFlowsFromNumbersPayloadT,
  GetQueryNumbersPagePayloadT,
} from '../api/types';

export const callFlowsActions = createActions(
  {
    CALL_FLOWS_FETCH_ALL: [
      (payload: FetchFlowsFromNumbersPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    CALL_FLOWS_DELETE: [
      (payload: DeleteFlowPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    TELEPHONY_GET_QUERY_NUMBERS_PAGE: [
      (payload: GetQueryNumbersPagePayloadT) => payload,
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },
  'CALL_FLOWS_FETCH_ALL_SUCCEEDED',
  'CALL_FLOWS_FETCH_ALL_FAILED',
  'CALL_FLOWS_DELETE_SUCCEEDED',
  'CALL_FLOWS_DELETE_FAILED',
  'TELEPHONY_GET_QUERY_NUMBERS_PAGE_SUCCEEDED',
  'TELEPHONY_GET_QUERY_NUMBERS_PAGE_FAILED',
);
